import apiClient from './apiClient';

export interface EvmSnapshotPoint {
  id: string;
  projectId: string;
  baselineId: string;
  wbsId: number | null;
  asOfDate: string;
  plannedValue: string | number;
  earnedValue: string | number;
  actualCost: string | number;
  scheduleVariance: string | number;
  costVariance: string | number;
  spi: string | number | null;
  cpi: string | number | null;
}

export interface InstructionReconciliationRow {
  taskId: string;
  taskCode: string;
  taskName: string;
  instructions: Array<{
    id: string;
    instructionNumber: string;
    declaredCostImpact: number;
    declaredScheduleImpactDays: number;
  }>;
  declaredCostTotal: number;
  declaredDaysTotal: number;
  baselineBudget: number;
  baselinePlannedEndDate: string | null;
  actualCost: number;
  actualEndDate: string;
  costDelta: number;
  slipDays: number | null;
  costDivergence: number;
  daysDivergence: number | null;
  diverged: boolean;
}

export interface InstructionReconciliationReport {
  baselineId: string | null;
  measuredTasks: InstructionReconciliationRow[];
  pendingTasks: number;
  unmeasurableInstructions: number;
}

class EvmService {
  /** Project-level EVM time series (wbsId omitted = project totals). */
  async getSeries(projectId: string, params?: { from?: string; to?: string }): Promise<EvmSnapshotPoint[]> {
    const response: any = await apiClient.get(`/evm/projects/${projectId}/series`, { params });
    return response.data ?? [];
  }

  async getInstructionReconciliation(projectId: string): Promise<InstructionReconciliationReport> {
    const response: any = await apiClient.get(`/evm/projects/${projectId}/instruction-reconciliation`);
    return response.data;
  }
}

export default new EvmService();
